export enum PercentageType
{
    Api = 1,
    Manual = 2
}